import { useIsSplitEnabled } from '@buffer-mono/features'

import { useTimezone } from '~publish/hooks/useTimezone'

import { getRecurrenceSummary } from './PostCardActions/recurrenceHelpers'
import { usePostData } from './PostCardContext'

export type RecurrenceInfo = {
  summary: string
  recurrentPostsLeft: number | null
}

/**
 * Returns recurrence info for the current post, or null if not recurring
 * or the feature flag is disabled. Must be used within a PostCardContext.
 */
export function usePostRecurrenceInfo(): RecurrenceInfo | null {
  const { recurrence, dueAt, status } = usePostData()
  const isEnabled = useIsSplitEnabled('publish-recurring-posts')
  const timeZone = useTimezone()

  if (status !== 'scheduled') return null

  const summary = getRecurrenceSummary(recurrence, dueAt, isEnabled, timeZone)
  return summary
    ? {
        summary,
        recurrentPostsLeft: recurrence?.recurrentPostsLeft ?? null,
      }
    : null
}
